class Ratio {
  static $16X10: string = '8x5';

  static $10X16: string = '5x8';

  static $16X9: string = '16x9';

  static $9X16: string = '9x16';

  static $4X3: string = '4x3';

  static $3X4: string = '3x4';

  static $3X2: string = '3x2';

  static $2X3: string = '2x3';

  static $1X1: string = '1x1';

  private h: number = 0;

  private v: number = 0;

  constructor(width: number, height: number) {
    this.detect(width, height);
    this.toString = this.toString.bind(this);
  }

  private detect = (width: number, height: number): void => {
    let h = width;
    let v = height;

    while (h && v) {
      if (h > v) {
        h %= v;
      } else {
        v %= h;
      }
    }
    h += v;

    this.h = width / h;
    this.v = height / h;
  };

  public get horizontal(): number {
    return this.h;
  }

  public get vertical(): number {
    return this.v;
  }

  public toString = (): string => `${this.h}x${this.v}`;

  public equal = (ratio: Ratio) => this.toString() === ratio.toString();
}

export default Ratio;
